







































































































import $ from 'jquery';
import {
    EventBus,
    hasElements,
    TypeEventBus,
    sortObjectByPropertyName,
    checkIfIDExistsInArray,
    getUniqueId,
    formatDate,
    ID,
    ColorsList
} from '../../core/utils';
import { Destroyed } from '../../core/decorators';
import { Component, Prop, Mixins, Vue, Watch, Emit } from 'vue-property-decorator';
import { PRIVILEGE_KEYS, PRIVILEGE_TYPES } from '../../core/utils/privileges';
import ConfirmAction from '../../core/components/ConfirmAction.vue';
import SetParameterValue from './SetParameterValue.vue';
import {
    MsgBox,
    Combobox,
    PlusEyeButtons,
    Breadcrums,
    CloseConfirmationModal,
    LoadingDialog
} from '../../core/components';
import Button from '../../core/components/Button.vue';
import {
    AuthStoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    StoreHelper,
    NotificationStoreHelper
} from '../../core/mixins';
import multiselect from 'vue-multiselect';
import Axios from 'axios';
import Loading from 'vue-loading-overlay';
import { config } from 'rxjs';
import moment, { invalid } from 'moment';
import { SettingsService } from '../api/SettingsService';
import { CompanyListItem } from '../models/Companies';
import { InsuranceServices } from 'features/insurance/api/InsuranceServices';
import { CompaniesService } from '../api/CompaniesService';
import DeleteConfirmation from '../../tracking/components/Geofences/DeleteConfirmation.vue'

@Component({
    components: {
        Loading,
        Combobox,
        Button,
        ConfirmAction,
        DeleteConfirmation
    }
})
export default class CompaniesActions extends Mixins(
    AuthStoreHelper,
    StoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    NotificationStoreHelper
) {
   @Prop({default: []}) selectedCompanies: Array<CompanyListItem>;
   noCompaniesSelectedAlert: string = 'No hay empresas seleccionadas';
   confirmMessage: string = '';
   confirmMessageBody: string = '';
   confirmMessageDebtTitle: string = 'Marcar Empresas CON Deuda';
   confirmMessageUnDebtTitle: string = 'Marcar Empresas SIN Deuda';
   confirmMessageDebtBody: string = '¿Está seguro que desea marcar CON Deuda las siguientes Empresas?';
   confirmMessageUnDebtBody: string = '¿Está seguro que desea marcar SIN Deuda las siguientes Empresas?';
   visibleConfirmDialog: boolean = false;
   action: number = -1;
   actionMarkWithDebt: number = 0;
   actionMarkWithoutDebt: number = 1;
   markingAsDebt: boolean = false;
   unMarkingDebt: boolean = false;
   suspendingService: boolean = false;
   restoringService: boolean = false;
   deleteMeSummaryMsg: Array<string> = [];
   deleteMeConfirmText: string = '';
   deleteMeSuspendServices: Array<string> = [
     'Sólamente usuarios con grupo "Smartway" podrán visualizar estas empresas',
   ]
   deleteMeRestoreServices: Array<string> = [
     'Los usuarios que tengan estas empresas podrán visualizarlas nuevamente',
   ]
   confirmBtnTextDeleteMe: string = '';
   confirmBtnTextSuspendService: string = 'Suspender servicio';
   confirmBtnTextRestoreService: string = 'Restaurar servicio';
   deleteMeBtnConfirmText: string = 'Si, deseo continuar';
   deleteMeAction: string = '';
   deleteMeActions: object = {
    suspend_services: 'suspender',
    restore_services: 'restaurar'
   }

   confirmationDelete: boolean = false;
   deleteModalTitle: string = '';
   deleteBody: string = '';
   colors: object = {
    suspend: ColorsList.orange,
    restore_services: ColorsList.skyblue
   }

   get canSetCompaniesWithDebt(){
    //tiene que haber empresas seleccionadas
    if(!this.existCompaniesToUpdate){
        return false
    }
    if(this.checkIfSelectedCompaniesAreValid(false) !== ''){
        //las empresas seleccionadas tienen que estar sin deuda
        return false
    }
    return true
   }

   get canSetCompaniesWithoutDebt(){
    //tiene que haber empresas seleccionadas
    if(!this.existCompaniesToUpdate){
        return false
    }
    if(this.checkIfSelectedCompaniesAreValid(true) !== ''){
        //las empresas seleccionadas tienen que estar CON deuda
        return false
    }
    return true
   }

   get canSuspendOrRestoreServices(){
    //habilitar botones de Suspender/Reactivar Servicios
    if(!this.existCompaniesToUpdate){
        //tiene que haber empresas seleccionadas
        return false
    }
    return true
   }

   
   get tooltipSuspendAndRestoreServices(){
    //Tooltip para botones de Suspender/Reactivar Servicio
    if(!this.existCompaniesToUpdate){
        return this.noCompaniesSelectedAlert
    }
    return ''
   }

    checkIfSelectedCompaniesAreValid(debtValue: boolean){
    //check if some companies doesn't match expected debt value
    let invalidCompanies = this.selectedCompanies.filter(item => item.debt !== debtValue);
    if(invalidCompanies.length > 0){
        return invalidCompanies.map(company => company.name).join(', ')
    }
    return ''
   }

   get tooltipMarkWithDebt(){
    if(!this.existCompaniesToUpdate){
        return this.noCompaniesSelectedAlert
    }
    let invalidCompanies = this.checkIfSelectedCompaniesAreValid(false);
    if(invalidCompanies !== ''){
        return 'Las siguientes empresas ya están marcadas con deuda:<br> ' + invalidCompanies
    }
    
   }
   get tooltipMarkWithoutDebt(){
    if(!this.existCompaniesToUpdate){
        return this.noCompaniesSelectedAlert
    }
    let invalidCompanies = this.checkIfSelectedCompaniesAreValid(true);
    if(invalidCompanies !== ''){
        return 'Las siguientes empresas NO están marcadas con deuda:<br> ' + invalidCompanies
    }
    
   }

   showSuspendServicesModal(){
    this.deleteModalTitle = 'Suspender servicio a Empresas';
    this.deleteBody = '¿Está seguro que desea suspender el servicio a las siguientes empresas? ' + this.getSelectedCompaniesNames();
    this.deleteMeSummaryMsg = this.deleteMeSuspendServices;
    this.deleteMeConfirmText = 'Para suspender el servicio escriba "suspender" en el campo de texto';
    this.confirmBtnTextDeleteMe = this.confirmBtnTextSuspendService;
    this.deleteMeAction = this.deleteMeActions['suspend_services'];
    this.confirmationDelete = true;
   }

   showRestoreServicesModal(){
    this.deleteModalTitle = 'Restaurar servicio a Empresas';
    this.deleteBody = '¿Está seguro que desea activarle nuevamente el servicio a las siguientes empresas? ' + this.getSelectedCompaniesNames();
    this.deleteMeSummaryMsg = this.deleteMeRestoreServices;
    this.deleteMeConfirmText = 'Para restaurar el servicio escriba "restaurar" en el campo de texto';
    this.confirmBtnTextDeleteMe = this.confirmBtnTextRestoreService;
    this.deleteMeAction = this.deleteMeActions['restore_services'];
    this.confirmationDelete = true;
   }

   confirmDeleteMe(action: boolean){
    if(!action){
        this.confirmationDelete = false;
        return
    }
    
    let companiesIds = this.getSelectedCompaniesIds();
    this.confirmationDelete = false;

    switch(this.deleteMeAction){
        case this.deleteMeActions['suspend_services']:
            this.suspendServices(companiesIds);
            return
        case this.deleteMeActions['restore_services']:
            this.restoreServices(companiesIds);
            return
    }
   }

   restoreServices(companiesIds: number[]){
    this.restoringService = true;
    CompaniesService.restoreServices(
        companiesIds
    ).then((res) => {
        this.$_successPatchRecipients(res.message);
        this.updateSuspendServices(companiesIds, false);
        this.cancelLoading();
    }).catch((error) => {
        this.cancelLoading();
        this.$_catchLoadingDialog({
            response: error.response.data || {},
            alternative_msg: 'Ocurrió un error'
        });
       
    })
   }

   suspendServices(companiesIds: number[]){
    this.suspendingService = true;
    CompaniesService.suspendServices(
        companiesIds
    ).then((res) => {
        this.cancelLoading();
        this.$_successPatchRecipients(res.message);
        this.updateSuspendServices(companiesIds, true);
    }).catch((error) => {
        this.$_catchLoadingDialog({
            response: error.response.data || {},
            alternative_msg: 'Ocurrió un error'
        });
        this.cancelLoading();
    })
   }

   
  
   showConfirmDebtModal(){
    this.confirmMessage = this.confirmMessageDebtTitle;
    this.confirmMessageBody = this.confirmMessageDebtBody + this.getSelectedCompaniesNames();
    this.action = this.actionMarkWithDebt;
    this.visibilityConfirmDialog(true);
   }

   showConfirmUnDebtModal(){
    this.confirmMessage = this.confirmMessageUnDebtTitle;
    this.confirmMessageBody = this.confirmMessageUnDebtBody + this.getSelectedCompaniesNames();
    this.action = this.actionMarkWithoutDebt;
    this.visibilityConfirmDialog(true);
   }

   getCompaniesToSubmit(){
    return {
        companies: this.getSelectedCompaniesIds()
    }
   }

   getSelectedCompaniesNames(){
        return ' <b>' + this.selectedCompanies.map(item => item['name']).join(', ') + '</b>';
   }

   getSelectedCompaniesIds(){
        return this.selectedCompanies.map(item => item['id']);
   }

   markCompaniesWithDebt(debtValue: boolean){
        let companiesIds = this.getSelectedCompaniesIds();
        CompaniesService.setCompaniesDebt(
            companiesIds,
            {
                debt: debtValue
            }
        ).then((res) => {
            this.cancelLoading();
            this.updateCompaniesDebt(companiesIds, debtValue);
            this.$_successPatchRecipients(res.message);
        }).catch((error) => {
            this.$_catchLoadingDialog({
                response: error.response.data || {},
                alternative_msg: 'Ocurrió un error'
            });
            this.cancelLoading();
        })
   }

   cancelLoading(){
    this.markingAsDebt = false;
    this.unMarkingDebt = false;
    this.suspendingService = false;
    this.restoringService = false;
   }

   @Emit()
   updateCompaniesDebt(companiesIds: ID[], newDebtValue: boolean){}

   @Emit() //actualizo valor de "suspended" en el listado
   updateSuspendServices(companiesIds: ID[], newSuspendedValue: boolean){}

   get existCompaniesToUpdate(){
    return this.selectedCompanies.length == 0 ? false : true
   }

   visibilityConfirmDialog(value: boolean){
    this.visibleConfirmDialog = value;
   }


    closeActiveConfirmationDialog(confirm: boolean) {
        if (confirm) {
            switch (this.action) {
                case this.actionMarkWithDebt:
                    this.markingAsDebt = true;
                    this.markCompaniesWithDebt(true);
                    break;
                case this.actionMarkWithoutDebt:
                    this.unMarkingDebt = true;
                    this.markCompaniesWithDebt(false);
                    break;
            
                default:
                    break;
            }
        }
        this.visibilityConfirmDialog(false)
    }

}
